








































































    
import {Vue, Component, Prop} from 'vue-property-decorator';
import { Payment, PaymentService } from '../services/accounting.service';

@Component({})
export default class PaymentConfirmation extends Vue {
    private api: PaymentService = new PaymentService();
    private payment: Payment | null = null;
    private loading: boolean = true;
    private error: string | null = null;

    async created() {
        const res = await this.api.getOne(this.$route.params.id);
        if (res.success === true) {
            this.payment = res.result;
            console.log(this.payment);
        } else {
            this.error = res.error.message;
        }
        this.loading = false;
    }

    private get totalAmount(): number {
        if (!this.payment) return 0;

        let sum = 0;

        for (const item of this.payment.invoice.items) {
            sum += item.quantity * item.rate;
        }

        return sum;
    }

}

